import { useState, useEffect } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const useSubscription = () => {
  const [subscriptionData, setSubscriptionData] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchSubscription = async () => {
    try {
      const response = await axios.get(`${API}/subscription/usage-status`);
      setSubscriptionData(response.data);
      return response.data;
    } catch (error) {
      console.error('Error fetching subscription:', error);
      return null;
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSubscription();
  }, []);

  const canCreateRecipe = () => {
    if (!subscriptionData) return true; // Allow if not loaded yet
    return subscriptionData.can_create_recipe;
  };

  const canUseAI = () => {
    if (!subscriptionData) return true; // Allow if not loaded yet
    return subscriptionData.can_use_ai;
  };

  const isPremium = () => {
    if (!subscriptionData) return false;
    return subscriptionData.subscription.plan === 'premium' || 
           subscriptionData.subscription.status === 'trial';
  };

  const getRecipesRemaining = () => {
    if (!subscriptionData || isPremium()) return -1; // Unlimited
    const used = subscriptionData.usage.recipes_this_month;
    const limit = subscriptionData.limits.recipes_per_month;
    return Math.max(0, limit - used);
  };

  const getAIRemaining = () => {
    if (!subscriptionData || isPremium()) return -1; // Unlimited
    const used = subscriptionData.usage.ai_generations_this_week;
    const limit = subscriptionData.limits.ai_generations_per_week;
    return Math.max(0, limit - used);
  };

  return {
    subscriptionData,
    loading,
    canCreateRecipe: canCreateRecipe(),
    canUseAI: canUseAI(),
    isPremium: isPremium(),
    recipesRemaining: getRecipesRemaining(),
    aiRemaining: getAIRemaining(),
    refresh: fetchSubscription
  };
};
